import React, { Component } from 'react';
import RUTransportsWRTTable from './RUTransportsWRTTable';


export class RUTransportsWRTContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent
    };
  }

  render() {

    return (
      <div>
        {this.state.content === 'ruTransportsWaitingRequest' ?
          <RUTransportsWRTTable handleChangeContent={this.props.handleChangeContent.bind(this)} />
          : null
        }
      </div>
    )

  }
}

export default RUTransportsWRTContent;


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/UsedRentalsWaitingRequest/RUTransportsWRTContent.js